import axios from "axios";

// AI service runs separately from Licensing.Admin.Api.
// Default port matches Licensing.AI.Api Kestrel default; override below for non-local envs.
//http://localhost:5050/


export const POST_AI_ASK       = "/api/ai/ask";
export const POST_AI_ANALYTICS = "/api/ai/analytics";



export async function askAi(question) {
  const { data } = await axios.post(POST_AI_ASK, { question });
  return data; // { answer, toolResults: [{ tool, args, result }, ...] }
}

// Direct aggregate query — bypasses the LLM. Cheap, deterministic, used by the
// Analytics tab charts. Pass any subset of {startDate, endDate, hoursBack,
// licenseType, productFamily, country, status, groupBy}.
export async function fetchAnalytics(params) {
  const { data } = await axios.post(POST_AI_ANALYTICS, params || {});
  return data; // { startDate, endDate, groupBy, total, breakdown: [{ groupKey, count }] }
}
